<section id="wrapper">
  <div class="login-register" style="background-image:url(./assets/images/background/login-register.jpg);">
    <div class="login-box card">
      <div class="card-body">
        <div [formGroup]="form" class="form-horizontal form-material" (keyup.enter)='onSubmit()' id="loginform">
          <h3 class="text-center m-b-20">Forgot Password</h3>
          <div class="col-xs-12">
            <div *ngIf="error" class="text-center invalid-feedback">
              {{error}}
            </div>
            <div class="form-group">
              <input class="form-control" formControlName="email" type="email" placeholder="Email">
              <app-errors [form_control]="f.email" [isSubmitted]="submitted"></app-errors>

            </div>
          </div>


          <div class="form-group text-center">
            <div class="col-xs-12 p-b-20">
              <button class="btn btn-block btn-lg btn-info btn-rounded" (click)="onSubmit()" type="submit">Send
                Email</button>
            </div>
          </div>


        </div>

        <!-- <form class="form-horizontal" id="recoverform" action="http://eliteadmin.themedesigner.in/demos/bt4/hospital/index.html">
                      <div class="form-group ">
                          <div class="col-xs-12">
                              <h3>Recover Password</h3>
                              <p class="text-muted">Enter your Email and instructions will be sent to you! </p>
                          </div>
                      </div>
                      <div class="form-group ">
                          <div class="col-xs-12">
                              <input class="form-control" type="text" required="" placeholder="Email"> </div>
                      </div>
                      <div class="form-group text-center m-t-20">
                          <div class="col-xs-12">
                              <button class="btn btn-primary btn-lg btn-block text-uppercase waves-effect waves-light" type="submit">Reset</button>
                          </div>
                      </div>
                  </form> -->
      </div>
    </div>
  </div>


</section>
<app-loader *ngIf='isloading'></app-loader>